import dayjs, { Dayjs } from "dayjs";

// MUI X date pickers (v6+) only accept Dayjs values - v5 parsed strings/Dates itself, so form values from the
// api (ISO strings), Date objects and empty strings are converted the same way the v5 dayjs adapter did
const toDayjsValue = (value: unknown): Dayjs | null => {
  if (value === null || value === undefined || value === "") return null;
  if (dayjs.isDayjs(value)) return value;

  return dayjs(value as string | number | Date);
};

export default toDayjsValue;
